var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 8.00002C0.666992 3.94993 3.95024 0.666687 8.00033 0.666687C12.0504 0.666687 15.3337 3.94993 15.3337 8.00002C15.3337 12.0501 12.0504 15.3334 8.00033 15.3334C3.95024 15.3334 0.666992 12.0501 0.666992 8.00002ZM8.00033 2.00002C4.68662 2.00002 2.00033 4.68631 2.00033 8.00002C2.00033 11.3137 4.68662 14 8.00033 14C11.314 14 14.0003 11.3137 14.0003 8.00002C14.0003 4.68631 11.314 2.00002 8.00033 2.00002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.593 6.27616C10.8533 6.53651 10.8533 6.95862 10.593 7.21897L7.76455 10.0474C7.5042 10.3077 7.08209 10.3077 6.82174 10.0474L5.40753 8.63319C5.14718 8.37284 5.14718 7.95073 5.40753 7.69038C5.66788 7.43003 6.08999 7.43003 6.35033 7.69038L7.29314 8.63319L9.65017 6.27616C9.91052 6.01581 10.3326 6.01581 10.593 6.27616Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d9eaeba6a370510f1008d3a406542044.svg";
export { ForwardRef as ReactComponent };